export default function(http) {
  return {
      queryByPage(data){
        return http.json({
          url: `/deduct/points/query`,
          data
        });
      },

      save(data) {
          return http.json({
              url: '/deduct/points/save',
              data
          })
      },
      getInfo(data) {
          return http.json({
              url: `/deduct/points/getById?id=${data.id}`
          })
      },
      /**
       * 删除版本
       * @param data
       * @return {*}
       */
      remove(data) {
          return http.json({
              url: `/deduct/points/delete?id=${data[0].id}`,
              data
          })
      },

  };
}



// WEBPACK FOOTER //
// ./src/configure/http/api/deductPoint.js